export function isTouchDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    (navigator?.msMaxTouchPoints || 0) > 0
  )
}

export default isTouchDevice
